import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Toaster } from "sonner"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import App from "./App"
import { AuthProvider } from "./contexts/AuthContext"
import { store, persistor } from "./store"
import "./index.css"
import { HelmetProvider } from "react-helmet-async"
import LoadingSpinner from "./components/LoadingSpinner"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate 
          loading={<div className="min-h-screen flex items-center justify-center"><LoadingSpinner size="lg" /></div>} 
          persistor={persistor}
        >
          <BrowserRouter>
            <AuthProvider>
              <App />
              <Toaster position="top-right" richColors expand visibleToasts={4} duration={4000} theme="light" />
            </AuthProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
)
